<div class="survey-analysis">
  <div class="loading-state" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    <span translate>WORK_ENVIRONMENT_SURVEY.LOADING</span>
  </div>

  <div class="empty-state" *ngIf="!isLoading && !surveyId">
    <p class="empty-state-title" translate>WORK_ENVIRONMENT_SURVEY.NO_SURVEYS_TITLE</p>
    <p class="empty-state-body" translate>WORK_ENVIRONMENT_SURVEY.NO_SURVEYS_BODY</p>
  </div>

  <ng-container *ngIf="!isLoading && surveyId && categories.length">
    <!-- Category selector -->
    <div class="category-tabs">
      <button
        type="button"
        class="category-tab"
        [class.active]="activeCategoryId === null"
        (click)="selectOverview()"
      >
        <span translate>WORK_ENVIRONMENT_SURVEY.OVERVIEW.TAB</span>
      </button>
      <button
        type="button"
        class="category-tab"
        *ngFor="let category of categories"
        [class.active]="activeCategoryId === category.Id"
        (click)="selectCategory(category.Id)"
      >
        {{ category.Name }}
      </button>
    </div>

    <!-- All categories at a glance -->
    <ng-container *ngIf="activeCategoryId === null">
      <div class="card category-summary">
        <div class="category-summary__item" *ngFor="let category of categories">
          <div class="category-summary__name">{{ category.Name }}</div>
          <survey-score-gauge
            [max]="5"
            [value]="meanFor(category.Id)"
          ></survey-score-gauge>
        </div>
      </div>

      <!-- Comments. Placeholder surface — nothing computes this yet. -->
      <div
        class="card comment-panel"
        *ngIf="insights && insights.Comments.length"
      >
        <div class="card-heading">
          <span translate>WORK_ENVIRONMENT_SURVEY.ANALYSIS.COMMENTS</span>
        </div>
        <div class="comment" *ngFor="let comment of insights.Comments">
          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
          <p class="comment__body">{{ comment }}</p>
        </div>
      </div>
    </ng-container>

    <!-- One category in detail -->
    <ng-container *ngIf="activeCategory as category">
      <div class="card category-detail">
        <div class="category-detail__intro">
          <h4>{{ category.Name }}</h4>
          <p>{{ category.Description }}</p>
        </div>

        <div class="category-detail__charts">
          <div class="chart-cell">
            <div class="chart-cell__title">{{ category.Name }}</div>
            <survey-score-gauge
              [max]="5"
              [value]="meanFor(category.Id)"
            ></survey-score-gauge>
          </div>

          <div class="chart-cell">
            <div class="chart-cell__title" translate>
              WORK_ENVIRONMENT_SURVEY.DEPARTMENT
            </div>
            <div
              class="chart-cell__chart"
              *ngIf="categoryDepartmentChartData; else categoryChartEmpty"
            >
              <p-chart
                type="bar"
                [data]="categoryDepartmentChartData"
                [options]="chartOptions"
                height="200px"
              ></p-chart>
            </div>
          </div>

          <div class="chart-cell">
            <div class="chart-cell__title" translate>
              WORK_ENVIRONMENT_SURVEY.HISTORY
            </div>
            <div
              class="chart-cell__chart"
              *ngIf="categoryHistoryChartData; else categoryChartEmpty"
            >
              <p-chart
                type="line"
                [data]="categoryHistoryChartData"
                [options]="chartOptions"
                height="200px"
              ></p-chart>
            </div>
          </div>
        </div>
      </div>

      <survey-question-scores
        [surveyId]="surveyId"
        [categoryId]="category.Id"
        [benchmarkIndex]="insights?.BenchmarkIndex ?? null"
      ></survey-question-scores>
    </ng-container>
  </ng-container>

  <ng-template #categoryChartEmpty>
    <div class="chart-cell__chart chart-cell__chart--empty">
      <span *ngIf="isCategoryLoading" translate>WORK_ENVIRONMENT_SURVEY.LOADING</span>
      <span *ngIf="!isCategoryLoading" translate>WORK_ENVIRONMENT_SURVEY.NO_RESULTS</span>
    </div>
  </ng-template>
</div>
